export default {
  settings: {
    label: 'Settings',
    language: {
      label: 'Language',
    },
  },
}
